import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import LeftArrow from "../../common/ArrowsButton/LeftArrow";
import RightArrow from "../../common/ArrowsButton/RightArrow";
import ArticleCard from "./ArticleCard";
import DotControls from "../../common/DotControls";

const LatestArticlesSection = ({ articles }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    dragFree: false,
    containScroll: "trimSnaps",
  });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  function handleNext() {
    emblaApi.scrollNext();
  }

  function handlePrev() {
    emblaApi.scrollPrev();
  }

  function handleGoTo(slide) {
    emblaApi.scrollTo(slide);
  }

  return (
    <div className="pt-10 w-full relative z-[1] overflow-visible embla">
      <div className="overflow-hidden" ref={emblaRef}>
        {prevBtnEnabled && <LeftArrow onClick={handlePrev} />}
        {nextBtnEnabled && emblaApi.slidesNotInView().length > 0 && (
          <RightArrow onClick={handleNext} />
        )}
        <div className="flex flex-row ml-5 xl:ml-16">
          {articles.map((article, index) => (
            <div
              className="flex-grow-0 flex-shrink-0 basis-[85%] md:basis-[45%] lg:basis-[31%] mr-5"
              key={index}
            >
              <ArticleCard key={index} article={article} />
            </div>
          ))}
        </div>
      </div>
      <div className="relative flex md:hidden w-full justify-center z-[1]">
        <DotControls
          arr={articles}
          activeIndex={selectedIndex}
          animationDuration="500ms"
          color="black"
          onClick={(e) => handleGoTo(e.clickedIndex)}
        />
      </div>
    </div>
  );
};

export default LatestArticlesSection;
